import { useDisplay } from 'vuetify';
import { appScale } from './appScale';

export function useWindowResize() {
    const display = useDisplay();

    const windowWidth = ref(window.innerWidth);
    const windowHeight = ref(window.innerHeight);

    const handleResize = () => {
        windowWidth.value = window.innerWidth;
        windowHeight.value = window.innerHeight;
    };

    const handleOrientationChange = () => {
        // add small delay to correctly handle orientationchange event
        setTimeout(handleResize, 100);
    };

    const isLandscapeMobile = computed(() => {
        // Use scale-aware virtual width so that zooming out can switch to desktop layout
        const scale = appScale.value;
        const virtualWidth = scale > 0 && scale < 1 ? display.width.value / scale : display.width.value;
        if (virtualWidth >= 960) return false;
        return windowWidth.value > windowHeight.value;
    });

    onMounted(() => {
        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleOrientationChange);
    });

    onBeforeUnmount(() => {
        window.removeEventListener('resize', handleResize);
        window.removeEventListener('orientationchange', handleOrientationChange);
    });

    return {
        windowWidth,
        windowHeight,
        isLandscapeMobile,
    };
}
